import React from 'react'
import styled from 'styled-components'
export default function DefaultTwoButtonLayer({title, onClickLeft,leftButtonText, onClickRight, rightButtonText, onClickClose}) {


    return(
        <BackDrop>
            <WrapperLayer>
                <WrapperCloseIcon>
                    <CloseIcon className="icon-close" onClick={onClickClose?onClickClose:onClickLeft}></CloseIcon>
                </WrapperCloseIcon>
                <WrapperTitleText>
                    {title}
                </WrapperTitleText>
                <WrapperButton>
                    <LeftButton onClick={onClickLeft}>
                        {leftButtonText}
                    </LeftButton>
                    <RightButton onClick={onClickRight}>
                        {rightButtonText}
                    </RightButton>
                </WrapperButton>
            </WrapperLayer>
        </BackDrop>
    )
}


const BackDrop = styled.div`
        height: 100%;
        left: 0;
        min-width: 950px;
        position: fixed;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 220;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
`

const WrapperLayer = styled.div`
    box-sizing: border-box;
    width: 346px;
    min-height: 155px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    padding: 14px 12px;
    border: 2px solid #333333;
`

const WrapperCloseIcon = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`

const CloseIcon = styled.button`
    font-size: 31px;
    color: #418DED;
    :hover {
        color: #005796;
    }
`

const WrapperTitleText = styled.div`
    width: 100%;
    font-weight: bold;
    font-size: 22px;
    margin-top: 17px;
    span {
        width: 100%;
        color: #333333;
        font-size: 22px;
        line-height: 28px;
        text-align: center;

        b {
            color: #3281ED;
        }
    }
`

const WrapperButton = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 21px;
    padding: 0 10px;
`

const LeftButton = styled.button`
    &&{
        width: 156px;
        height: 40px;
        border: 2px solid #418DED;
        text-align: center;
        color: #418DED;
        font-size: 16px;
        font-weight: bold;
        line-height: 21px;
        background-color: #fff;
        margin-right: 10px;
        :hover{
            background-color: #F6F6F6;
        }
    }
`

const RightButton = styled.button`
    &&{
        width: 156px;
        height: 40px;
        border: 2px solid #418DED;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        line-height: 21px;
        background-color: #418DED;
        :hover{
            background-color: #2D7EE4;
        }
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/defaultTwoButtonLayer.js